module.exports = __webpack_public_path__ + "img/762dc.45230826.svg";